<template>
  <teleport to="body">
    <ModalView :isOpen="isOpen" title="Terms and Conditions" @close="close">
      <div class="content">
        <p>To continue using GRAP, please review and accept the Terms and Conditions.</p>
        <div class="terms-box">
          <h4>Summary</h4>
          <ul>
            <li>This app is for informational purposes only and is not medical advice.</li>
            <li>Your data is stored securely; see our privacy section for details.</li>
            <li>Use the app responsibly and keep your account secure.</li>
          </ul>
          <p>
            Full text is available in Registration. We will add a dedicated page soon.
          </p>
        </div>
      </div>
      <template #footer>
        <div class="footer">
          <button class="secondary-button" @click="close">Not now</button>
          <button :disabled="submitting" @click="accept">
            <LoadingIndicator v-if="submitting" text="Saving..." size="small" />
            <span v-else>I Accept</span>
          </button>
        </div>
      </template>
    </ModalView>
  </teleport>
  
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import ModalView from './ModalView.vue'
import LoadingIndicator from './LoadingIndicator.vue'
import { useAuthStore } from '../stores/auth'
import { useFeaturesStore } from '../stores/features'
import apiService from '../services/apiService'

const authStore = useAuthStore()
const featuresStore = useFeaturesStore()
const isOpen = computed(() => {
  // Don't show if T&C is disabled via feature flag
  if (featuresStore.isTermsAndConditionsDisabled) {
    return false
  }
  return !!authStore.isAuthenticated && !!authStore.user && authStore.user.terms_accepted === false
})
const submitting = ref(false)

function close() {
  // Keep prompting until accepted; do nothing on close
}

async function accept() {
  if (!authStore.user) return
  try {
    submitting.value = true
    await apiService.post(`/users/${authStore.user.id}/accept-terms`)
    // Refresh user data
    await authStore.fetchUserData()
  } finally {
    submitting.value = false
  }
}
</script>

<style scoped>
.content {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.terms-box {
  border: 1px solid var(--border-color);
  background: var(--background-color);
  padding: 1rem;
  border-radius: 8px;
}
.footer {
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
}
.secondary-button {
  background: var(--border-color);
  color: var(--text-color);
}
</style>


